import { Toaster } from '@components/ui/sonner';
import { AuthProvider } from '@contexts/auth/provider';
import ErrorBoundary from '@routes/ErrorBoundary';
import Routes from '@routes/index';
import Redirect from '@services/utils/Redirect';
import { BrowserRouter } from 'react-router';

function App() {
  return (
    <AuthProvider>
      <ErrorBoundary>
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      </ErrorBoundary>
      <Redirect />
      <Toaster />
    </AuthProvider>
  );
}

export default App;
